import { connect } from 'react-redux';
import { getSelectorOptions } from '../../../actions/uiElements';
import Selector from '../../../components/common/Selector/Selector';
import _ from '../../../utils/lodash';

function mapOptionSelectionToFlatValue(selection, options, isMultiple, mapWithoutId, setValueValidity) {
  if (!isMultiple && Array.isArray(selection)) {
    // eslint-disable-next-line no-console
    console.warn('Expected single value for Selector but received an array!');
  }

  if (!isMultiple) {
    if (mapWithoutId) {
      selection = _.find(options, ['name', selection]);
      if (setValueValidity) setValueValidity(selection === undefined);
    }
    return selection ? selection.id : undefined;
  }

  return selection && options ? selection.filter(s => options.find(o => o.id === s.id)).map(s => s.id) : undefined;
}

const mapStateToProps = (
  { uiElements: { selectors } },
  { value, multiple, reduxIdentifier, innerRef, mapWithoutId, setValueValidity },
) => {
  if (selectors[reduxIdentifier]) {
    const source = selectors[reduxIdentifier];
    const options = source.options;

    const hasValue = !_.isEmpty(value) && (typeof value === 'object' && !_.isEmpty(value.id) && !_.isEmpty(value.name));
    if (!Array.isArray(value) && hasValue && _.find(options, ['id', value.id]) === undefined) {
      options.push(value);
    }

    return {
      ref: innerRef,
      isFetching: source.isFetching,
      options,
      originalValue: value,
      value: mapOptionSelectionToFlatValue(value, options, multiple, mapWithoutId, setValueValidity),
    };
  }
  return {
    ref: innerRef,
    isFetching: false,
    options: [],
    value: undefined,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  getOptions: () => dispatch(getSelectorOptions(props.endpoint, props.reduxIdentifier, props.callArgs)),
  filterOptions: options => {
    if (!props.filterOptions) {
      return options;
    }
    return props.filterOptions(options);
  },
  mapOptions: options => {
    if (!props.mapOptions) {
      return options;
    }
    return props.mapOptions(options);
  },
  mapValue: options => {
    if (!props.mapOptions) {
      return options;
    }
    return props.mapValue(options);
  },
});

const OptionsSelector = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: false },
)(Selector);

export default OptionsSelector;
